import { useTheme } from "next-themes";
import useTranslation from "next-translate/useTranslation";
import { Radar } from "react-chartjs-2";
import { Tag } from "rsuite";
import { IAppreciationDistributeMaturityLevelByDimension } from "types/Appreciation/AppreciationDistribute.type";

interface IAppreciationResultsProps {
  userMaturityLevelByDimension: IAppreciationDistributeMaturityLevelByDimension[];
  maxWidth?: number;
  showDetails?: boolean;
  showTitle?: boolean;
  userGeneralMaturity?: number;
  borderRadious?: boolean;
  noPadding?: boolean;
}

const AppreciationResultsChart = (props: IAppreciationResultsProps) => {
  const {
    userMaturityLevelByDimension,
    maxWidth,
    showDetails = true,
    showTitle = true,
    userGeneralMaturity = null,
    borderRadious = false,
    noPadding = false,
  } = props;
  const { theme } = useTheme();
  const { t } = useTranslation("common");

  return (
    <div
      className={`flex flex-col items-center justify-center bg-transparent dark:bg-gray-900 ${
        borderRadious ? "rounded-lg" : ""
      } ${noPadding ? "p-2" : "p-3 md:p-6"}`}
    >
      {showTitle && (
        <div className="mb-4 flex items-center align-middle">
          <span className="mr-1 text-xl text-gray-800 dark:text-gray-200">
            {t("Evaluación")}:
          </span>
          {userGeneralMaturity !== null && (
            <span className="text-xl font-semibold text-blue-500">
              {userGeneralMaturity.toFixed(2)}%
            </span>
          )}
        </div>
      )}
      {userMaturityLevelByDimension &&
        userMaturityLevelByDimension.length >= 3 && (
          <div
            className="flex w-full items-center justify-center"
            style={{ maxWidth: maxWidth || 800 }}
          >
            <Radar
              options={{
                plugins: {
                  legend: {
                    display: false,
                  },
                },

                scales: {
                  r: {
                    suggestedMin: 0,
                    suggestedMax: 100,
                    grid: {
                      color:
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.3)"
                          : "rgba(0, 0, 0, 0.3)",
                    },
                    angleLines: {
                      color:
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.3)"
                          : "rgba(0, 0, 0, 0.3)",
                    },
                    pointLabels: {
                      color:
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.9)"
                          : "rgba(0, 0, 0, 0.9)",
                    },
                    ticks: {
                      display: false,
                    },
                  },
                },
              }}
              data={{
                labels: userMaturityLevelByDimension.map((item) => {
                  const splitted = item.dimensionName.split(" ");

                  return splitted;
                }),

                datasets: [
                  {
                    data: userMaturityLevelByDimension.map(
                      (item) => item.percent
                    ),

                    fill: true,
                    backgroundColor: [
                      "rgba(63, 51, 255, 0.2)",
                      "rgba(99, 255, 51, 0.2)",
                      "rgba(255, 51, 51, 0.2)",
                    ],
                    borderColor: "rgba(63, 51, 255, 1)",
                    pointBackgroundColor: "rgba(63, 51, 255, 1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(63, 51, 255, 1)",
                  },
                ],
              }}
            />
          </div>
        )}
      {showDetails && (
        <div className="w-full">
          {userMaturityLevelByDimension?.map((item) => (
            <div className="mb-1 flex justify-between" key={item.dimensionName}>
              <span className="font-semibold text-gray-800 dark:text-gray-300">
                {item.dimensionName}
              </span>
              <div className="flex-1 border-b border-gray-500" />
              <Tag className="ml-2">{item.maturityname}</Tag>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppreciationResultsChart;
